import assert from 'assert';
import { abi as batchExchangeAbiJson } from '@gnosis.pm/dex-contracts/build/contracts/BatchExchange.json';
import erc20AbiJson from "./abi/Erc20.json";
import wethAbiJson from "./abi/Weth.json";
import tcrAbiJson from "./abi/Tcr.json";
export const erc20Abi = erc20AbiJson;
export const batchExchangeAbi = batchExchangeAbiJson;
export const wethAbi = wethAbiJson;
export const tcrAbi = tcrAbiJson;
export function createBatchExchangeContract(web3, address) {
    const batchExchangeAddress = address || process.env.STABLE_COIN_CONTRACT_ADDRESS;
    assert(batchExchangeAddress, 'address param, or STABLE_COIN_CONTRACT_ADDRESS env is required');
    // FIXME: There's an issue with this conversion: https://github.com/gnosis/dex-telegram/issues/14
    const unknownContract = new web3.eth.Contract(batchExchangeAbi, batchExchangeAddress);
    return unknownContract;
}
export function createErc20Contract(web3, address) {
    // FIXME: There's an issue with this conversion: https://github.com/gnosis/dex-telegram/issues/14
    const unknownContract = new web3.eth.Contract(erc20Abi, address);
    return unknownContract;
}
export function createWrapEtherContract(web3, address) {
    // FIXME: There's an issue with this conversion: https://github.com/gnosis/dex-telegram/issues/14
    const unknownContract = new web3.eth.Contract(wethAbi, address);
    return unknownContract;
}
export function createTcrContract(web3, address) {
    // FIXME: There's an issue with this conversion: https://github.com/gnosis/dex-telegram/issues/14
    const unknownContract = new web3.eth.Contract(tcrAbi, address);
    return unknownContract;
}
//# sourceMappingURL=index.js.map